// import config from '../config.json'
// export default {
//   base_url: config.api_url,
//   thumb_url: config.thumb_url,
//   file_url: config.file_url,
//   audio_url: config.audio_url,
//   video_url: config.video_url,
//   other_url: config.other_url,
//   th_thumb_url: config.th_thumb_url,
//   domain: config.domain,
//   cookie_prefix: config.cookie_prefix,
//   teacher_url: config.teacher_url
// }
let config = {}
console.log(process.env.NODE_ENV)
// 'http://10.204.42.156:9099'

let baseUrlConfig = {
  dev: 'https://dev.keyclass.cn',
  uat: 'https://uat.keyclass.cn',
  pro: 'https://www.keyclass.cn'
}

let baseUrl = baseUrlConfig[process.env.NODE_ENV]

if (process.env.NODE_ENV === 'dev') {
  config = {
    site_name: 'dev',
    local_url: baseUrl + '/studentServer',
    login_url: baseUrl + '/studentServer',
    base_url: baseUrl + '/studentServer',
    agent_url: baseUrl + '/agentServer',
    teacher_url: baseUrl + '/teacherServer',
    thumb_url: baseUrl + '/adminServer/fileUpload/imgUpload',
    file_url: baseUrl + '/adminServer/fileUpload/fileUpload',
    audio_url: baseUrl + '/adminServer/fileUpload/audioUpload',
    video_url: baseUrl + '/adminServer/fileUpload/videoUpload',
    other_url: baseUrl + '/adminServer/fileUpload/otherUpload',
    p2p_url: 'https://test.usongshu.com',
    cookie_prefix: 'qd_'
  }
} else if (process.env.NODE_ENV === 'uat') {
  config = {
    local_url: window.location.origin + '/studentServer',
    login_url: baseUrl + '/studentServer',
    base_url: baseUrl + '/studentServer',
    agent_url: baseUrl + '/agentServer',
    teacher_url: baseUrl + '/teacherServer',
    thumb_url: baseUrl + '/adminServer/fileUpload/imgUpload',
    file_url: baseUrl + '/adminServer/fileUpload/fileUpload',
    audio_url: baseUrl + '/adminServer/fileUpload/audioUpload',
    video_url: baseUrl + '/adminServer/fileUpload/videoUpload',
    other_url: baseUrl + '/adminServer/fileUpload/otherUpload',
    p2p_url: 'https://test.usongshu.com',
    cookie_prefix: 'qd_'
  }
} else if (process.env.NODE_ENV === 'pro') {
  config = {
    local_url: window.location.origin + '/studentServer',
    login_url: baseUrl + '/studentServer',
    base_url: baseUrl + '/studentServer',
    agent_url: baseUrl + '/agentServer',
    teacher_url: baseUrl + '/teacherServer',
    thumb_url: baseUrl + '/adminServer/fileUpload/imgUpload',
    file_url: baseUrl + '/adminServer/fileUpload/fileUpload',
    audio_url: baseUrl + '/adminServer/fileUpload/audioUpload',
    video_url: baseUrl + '/adminServer/fileUpload/videoUpload',
    other_url: baseUrl + '/adminServer/fileUpload/otherUpload',
    p2p_url: 'https://point.usongshu.com',
    cookie_prefix: 'qd_'
  }
}
export default config



// WEBPACK FOOTER //
// ./src/global/configure.js